import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { queryClientConfig } from 'hooks/config';

export const queryClient = new QueryClient({
  ...queryClientConfig,
  queryCache: new QueryCache({
    // eslint-disable-next-line no-console
    onError: (error) => console.error(error),
  }),
  mutationCache: new MutationCache({
    // eslint-disable-next-line no-console
    onError: (error) => console.error(error),
  }),
});
